import React, { useState, useEffect } from "react";
import { Input } from "../design/input";
import { Select } from "../design/select";

const countries = [
  { value: "+1", label: "+1 (US)", maxDigits: 10 },
  { value: "+44", label: "+44 (UK)", maxDigits: 10 },
];

interface PhoneNumberInputProps {
  defaultValue: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const formatPhoneNumber = (digits: string) => {
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  defaultValue,
  value,
  onChange,
  placeholder,
}) => {
  const getInitialCountry = () => {
    const country = countries.find((c) => defaultValue.startsWith(c.value));
    return country || countries[0];
  };

  const [country, setCountry] = useState(getInitialCountry());
  const [localDigits, setLocalDigits] = useState(
    value.replace(/\D/g, "").replace(country.value.replace("+", ""), "")
  );

  useEffect(() => {
    const matched = countries.find((c) => value.startsWith(c.value)) || countries[0];
    const digits = value.replace(/\D/g, "").replace(matched.value.replace("+", ""), "");
    setCountry(matched);
    setLocalDigits(digits.slice(0, matched.maxDigits));
  }, [value]);

  useEffect(() => {
    const matched = countries.find((c) => defaultValue.startsWith(c.value)) || countries[0];
    const digits = defaultValue.replace(/\D/g, "").replace(matched.value.replace("+", ""), "");
    setCountry(matched);
    setLocalDigits(digits.slice(0, matched.maxDigits));
  }, [defaultValue]);

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = countries.find((c) => c.value === e.target.value);
    if (!selected) return;
    setCountry(selected);
    setLocalDigits((prev) => {
      const sliced = prev.slice(0, selected.maxDigits);
      onChange(`${selected.value}${sliced}`);
      return sliced;
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, country.maxDigits);
    setLocalDigits(digits);
    onChange(`${country.value}${digits}`);
  };

  return (
   <div className="flex items-center w-full gap-x-2">
      <div className="flex-shrink-0">
      <Select value={country.value} onChange={handleCountryChange}>
        {countries.map((c) => (
          <option key={c.value} value={c.value}>
            {c.label}
          </option>
        ))}
      </Select>
      </div>
      <Input
        type="tel"
        inputMode="numeric"
        value={formatPhoneNumber(localDigits)}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default PhoneNumberInput;